import { ChakraProvider } from '@chakra-ui/provider';

import { theme } from '@revelio/styles';
import { Text } from '@revelio/ui';

import { MarkdownRenderer } from './MarkdownRenderer';
import documentationContent from './text-chart-documentation.md';
import styles from './text-chart-help-page.module.css';

export const TextChartHelpPage = () => {
  return (
    <ChakraProvider theme={theme}>
      <div className={styles.page}>
        <div className={styles.container}>
          <Text as="h1" fontSize="lg" className={styles.title}>
            Text Chart Template Guide
          </Text>
          <div className={styles.panel}>
            <MarkdownRenderer content={documentationContent} />
          </div>
        </div>
      </div>
    </ChakraProvider>
  );
};
